import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useTranslation } from 'react-i18next';
import BurgerMenu from '../../commons/BurgerMenu';
import Header from '../../commons/Header';
import { ReactComponent as IconDashboard } from '../../images/icn_dashboard.svg';
import { ReactComponent as IconBack } from '../../images/icn-back.svg';
import {
  BtnRadiusWhite,
  ContFilterYear,
  ContFlexLeft,
  ContPaginationPage,
  H4Styled,
  VerticalSpacing,
} from '../../styled-components';
import { Col, CustomInput, FormGroup, Label, Row } from 'reactstrap';
import variables from '../../variables';
import generateMonthOptions from '../../lib/helpers/generateMonthOptions';
import SearchInput from '../../commons/SearchInput';
import TotalTr from './TotalTr';
import DashboardDetailTable from './Table';
import generateYearOptions from '../../lib/helpers/generateYearOptions';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';

function DashboardDetailCompensiPresentational({
  data = [],
  dataExport = [],
  fetchCompensiExport,
  isReady = false,
  setIsReady,
  total = 0,
  year,
  query,
  onFilter,
  history,
}) {
  const [t] = useTranslation('INSURANCES');
  const [decoratedData, setDecoratedData] = useState(data);
  const alert = useAlert();

  useEffect(() => {
    setDecoratedData(
      data?.map((insurance) => ({
        ...insurance,
      }))
    );
  }, [data]);

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <section>
          <Header
            title={t('PAGES:DASHBOARD')}
            icon={<IconDashboard fill={variables.white} />}
          />
        </section>

        <section>
          <Row>
            <Col md="12" lg="6">
              <ContFlexLeft>
                <BtnRadiusWhite onClick={() => history.replace('/dashboard')}>
                  <IconBack fill={variables.primary} />
                </BtnRadiusWhite>

                <H4Styled>{t('INSURANCES:ROYALTIES_TITLE')}</H4Styled>
              </ContFlexLeft>
            </Col>
          </Row>

          <VerticalSpacing>
            <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('START_DATE')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="selectinsuranceStartYear"
                          name="insuranceStartYear"
                          value={query && query.insuranceStartYear}
                          onChange={({
                            target: { value: insuranceStartYear },
                          }) => {
                            onFilter({ insuranceStartYear });
                          }}
                        >
                          {generateYearOptions(true)}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('INSURANCES:TITLE_FILTER_SIGNIN_MONTH')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="insuranceStartMonth"
                          name="insuranceStartMonth"
                          disabled={!query.year}
                          value={query && query.insuranceStartMonth}
                          onChange={({
                            target: { value: insuranceStartMonth },
                          }) => onFilter({ insuranceStartMonth })}
                        >
                          {generateMonthOptions()}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('END_DATE')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="selectinsuranceEndYear"
                          name="insuranceEndYear"
                          value={query && query.insuranceEndYear}
                          onChange={({
                            target: { value: insuranceEndYear },
                          }) => {
                            onFilter({ insuranceEndYear });
                          }}
                        >
                          {generateYearOptions(true)}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('TITLE_FILTER_END_MONTH')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="insuranceEndMonth"
                          name="insuranceEndMonth"
                          disabled={!query.insuranceEndYear}
                          value={query && query.insuranceEndMonth}
                          onChange={({
                            target: { value: insuranceEndMonth },
                          }) => onFilter({ insuranceEndMonth })}
                        >
                          {generateMonthOptions()}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.policy_code }}
                  onFilter={({ search }) => onFilter({ policy_code: search })}
                  label={t('SEARCH:POLICY_CODE')}
                />
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.admin_cf }}
                  onFilter={({ search }) => onFilter({ admin_cf: search })}
                  label={t('SEARCH:REFERENCE_ID')}
                />
              </Col>

              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.customer }}
                  onFilter={({ search }) => onFilter({ customer: search })}
                  label={t('SEARCH:CUSTOMER')}
                />
              </Col>

              <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>Tipologia cliente</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="customerType"
                          name="customerType"
                          value={query.customerType}
                          onChange={({ target: { value: customerType } }) =>
                            onFilter({ customerType })
                          }
                        >
                          <option value="" defaultChecked>
                            Tutti
                          </option>
                          <option value="condos">Condomini</option>
                          <option value="customerExtra">Clienti privati</option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('SEARCH:AGENCY_TYPE')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="agencyType"
                          name="agencyType"
                          value={query.agencyType}
                          onChange={({ target: { value: agencyType } }) =>
                            onFilter({ agencyType })
                          }
                        >
                          <option value="" defaultChecked>
                            Tutti
                          </option>
                          <option value="VITTORIA">VITTORIA</option>
                          <option value="ITAS">ITAS</option>
                          <option value="ITALIANA_ASSICURAZIONI">
                            ITALIANA ASSICURAZIONI
                          </option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>Stato assicurazione</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="active"
                          name="active"
                          value={query.active}
                          onChange={({ target: { value: active } }) =>
                            onFilter({ active })
                          }
                        >
                          <option value="" defaultChecked>
                            Tutti
                          </option>
                          <option value="active">Attive</option>
                          <option value="terminated">Scadute</option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
            </Row>

            <br />

            <section className="m-t-20">
              <DashboardDetailTable
                data={decoratedData}
                total={total}
                onFilter={onFilter}
                query={query}
                bottomRow={<TotalTr data={decoratedData} />}
              />

              <ContPaginationPage>
                <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

                <FormGroup>
                  <CustomInput
                    type="select"
                    className="pagination-select"
                    id="perPage"
                    name="perPage"
                    value={query.limit}
                    onChange={({ target: { value: limit } }) => {
                      onFilter({ limit: limit });
                    }}
                  >
                    {generatePaginationOptions()}
                  </CustomInput>
                </FormGroup>
              </ContPaginationPage>
            </section>
          </VerticalSpacing>
        </section>
      </div>
    </div>
  );
}

export default DashboardDetailCompensiPresentational;
